import type { CSSProperties, ReactNode } from 'react';

export interface SliderProps {
    value?: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (value: number) => void;
    label?: ReactNode;
    /** Unidade exibida ao lado do valor, ex.: `%`. */
    suffix?: string;
    disabled?: boolean;
    /** Nome acessível quando não há `label` visível. */
    ariaLabel?: string;
    style?: CSSProperties;
}

export function Slider({
    value = 0, min = 0, max = 100, step = 1, onChange, label, suffix = '', disabled = false, ariaLabel, style,
}: SliderProps) {
    const pct = ((value - min) / (max - min)) * 100;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
            {label && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--neutral-700)', fontWeight: 500 }}>
                    <span>{label}</span>
                    <span style={{ color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>{value}{suffix}</span>
                </div>
            )}
            <input
                type="range" min={min} max={max} step={step} value={value} disabled={disabled}
                aria-label={typeof label === 'string' ? label : ariaLabel}
                onChange={(e) => onChange?.(Number(e.target.value))}
                style={{
                    WebkitAppearance: 'none', appearance: 'none', width: '100%', height: 4, borderRadius: 'var(--radius-pill)',
                    background: `linear-gradient(to right,var(--burgundy-700) ${pct}%,var(--neutral-200) ${pct}%)`,
                    outline: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
                }}
            />
            <style>{'input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:16px;height:16px;border-radius:50%;background:#fff;border:1px solid var(--border-strong);box-shadow:var(--shadow-sm);cursor:pointer}'}</style>
        </div>
    );
}
